import STRIPE from './stripe'

export default {
  STRIPE,
}
